import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import { hillo } from 'hillo'
import { baseUrl } from '@/model/dataLayer/api/SaaS/serviceUsageService'
import GlobalConfig from '@/model/global/GlobalSettings'

export const promotionTypeList = [
  { label: '时间范围', value: 'TIME_RANGE' },
  { label: '日期范围', value: 'DATE_RANGE' },
  { label: '特定星期几', value: 'DAY_OF_WEEK' },
  { label: '指定菜品', value: 'DISH_CODE' },
  { label: '指定分类', value: 'CATEGORY_DE_NAME' },
  { label: '最低消费', value: 'MINIMUM_PURCHASE' }
]

export const promotionActionList = [
  { label: '固定金额', value: 'FIXED_AMOUNT_DISCOUNT' },
  { label: '百分比折扣', value: 'PERCENTAGE_DISCOUNT' },
  { label: '特定价格', value: 'SET_PRICE' },
  { label: '免费升级', value: 'FREE_UPGRADE' },
  { label: '终端提示', value: 'TERMINAL_PROMPT' }
]

export const dayOfWeekDisplay = [
  {
    label: '星期一',
    value: '1'
  }, {
    label: '星期二',
    value: '2'
  }, {
    label: '星期三',
    value: '3'
  }, {
    label: '星期四',
    value: '4'
  }, {
    label: '星期五',
    value: '5'
  }, {
    label: '星期六',
    value: '6'
  }, {
    label: '星期天',
    value: '0'
  }
]

// Helper function to format a predicate for display
function formatPredicate (predicate) {
  const typeLabel = promotionTypeList.find(x => x.value === predicate.type).label
  let valueDisplay = ''

  // Format value based on predicate type
  switch (predicate.type) {
    case 'TIME_RANGE':
      if (predicate.timeRanges && predicate.timeRanges.length) {
        valueDisplay = predicate.timeRanges.map(range => range.join('-')).join(',')
      }
      break
    case 'DATE_RANGE':
      if (predicate.start && predicate.end) {
        valueDisplay = `${predicate.start} - ${predicate.end}`
      }
      break
    case 'DAY_OF_WEEK':
      if (predicate.days && predicate.days.length) {
        valueDisplay = predicate.days.map(day =>
          dayOfWeekDisplay.find(d => d.value === day)?.label || day
        ).join(',')
      }
      break
    case 'DISH_CODE':
      if (predicate.dishCodes && predicate.dishCodes.length) {
        valueDisplay = `${predicate.dishCodes.length}个菜品`
      }
      break
    case 'CATEGORY_DE_NAME':
      if (predicate.categoryNames && predicate.categoryNames.length) {
        valueDisplay = `${predicate.categoryNames.length}个分类`
      }
      break
    case 'MINIMUM_PURCHASE':
      if (predicate.amount) {
        valueDisplay = `€${predicate.amount}`
      }
      break
  }

  return `${typeLabel}: ${valueDisplay}`
}

// Helper function to format an action for display
function formatAction (action) {
  const typeLabel = promotionActionList.find(x => x.value === action.type).label
  let valueDisplay = ''

  // Format value based on action type
  switch (action.type) {
    case 'FIXED_AMOUNT_DISCOUNT':
      if (action.amount) {
        valueDisplay = `€${action.amount}`
      }
      break
    case 'PERCENTAGE_DISCOUNT':
      if (action.percentage) {
        valueDisplay = `${action.percentage}%`
      }
      break
    case 'SET_PRICE':
      if (action.price) {
        valueDisplay = `€${action.price}`
      }
      break
    case 'FREE_UPGRADE':
      if (action.targetDishCode) {
        valueDisplay = action.targetDishCode
      }
      break
    case 'TERMINAL_PROMPT':
      if (action.title) {
        valueDisplay = action.title
      }
      break
  }

  return `${typeLabel}: ${valueDisplay}`
}

const entity = {
  ruleName: {
    displayName: 'RulesName'
  },
  predicatesType: {
    displayName: 'Typ'
  },
  actionsType: {
    displayName: 'Details'
  },
  statusDisplay: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  isActive: {
    type: IKDataEntity.Types.Boolean,
    displayName: 'isActive'
  },
  operation: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }
}

const config = {
  load: async function (filter) {
    const res = (await hillo.get(baseUrl + 'promotion-rules/bl/' + GlobalConfig.blId, {
      withDeleted: true
    })).map(it => {
      const predicatesDisplay = JSON.parse(it.predicates)
      const actionDisplay = JSON.parse(it.actions)

      // Format predicates with type and value
      it.predicatesType = predicatesDisplay.map(formatPredicate).join('|')

      // Format actions with type and value
      it.actionsType = actionDisplay.map(formatAction).join('|')
      it.status = it.deletedAt ? '已失效' : '正常'

      return it
    })
    return res
  },
  add: async function (item) {
    return savePromotionData(item)
  },
  edit: async function (item) {
    return savePromotionData(item)
  },
  remove: async function (id) {
    return (await hillo.jsonPost(baseUrl + 'promotion-rules/delete/' + id, {}))
  }
}

// Helper function for saving promotion data
export async function savePromotionData (item) {
  return (await hillo.jsonPost(baseUrl + 'promotion-rules/save', {
    blId: GlobalConfig.blId,
    ...item
  }))
}

export default IKDataEntity.ModelFactory(entity, config)

export async function restorePromotion (id) {
  return (await hillo.jsonPost(baseUrl + 'promotion-rules/restore/' + id, {}))
}
